/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { ActionRequest, Asset, EntryPoint, MenuItem } from '@wit/vtv-x-foundation-lib';
import { AnyAction } from 'redux';
import { take, TakeEffect } from 'redux-saga/effects';

export interface PiContext {
  entryAssetId: number;
  entryAssetMediaType: string;
  entryAsset?: Asset;
  entryPoint?: EntryPoint;
  entryMenuItem?: MenuItem;
}

export enum ActionType {
  START = 'programInfo/startContext',
  CLEAR = 'programInfo/clearContext',
}

type StartContext = ActionRequest<ActionType.START, PiContext>;
type ClearContext = ActionRequest<ActionType.CLEAR, PiContext>;

export type Actions = StartContext | ClearContext;

export const ActionCreators = {
  start: (context: PiContext): StartContext => ({
    type: ActionType.START,
    meta: context,
  }),
  clear: (context: PiContext): ClearContext => ({
    type: ActionType.CLEAR,
    meta: context,
  }),
};

const NO_ENTRY_POINT = 'noEntryPoint';
export function getContextId(ctx: PiContext): string {
  return `${ctx.entryAssetMediaType}/${ctx.entryAssetId}/${ctx.entryPoint || NO_ENTRY_POINT}`;
}

// helper function that checks the action type and also the context
export function takeCtx(actionType: ActionType, ctx: PiContext): TakeEffect {
  // first tries a reference comparing and then compares the contextId
  return take(
    (act: AnyAction) => act.type === actionType && (act.meta === ctx || getContextId(act.meta) === getContextId(ctx))
  );
}
